"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authenticatedShareLinkUrl = exports.anonymousShareLinkUrl = exports.useShareLink = void 0;
const api_1 = require("@streem/api");
const react_1 = require("react");
// NOTE: Once ST-2681 is complete we will be able to grab the url from whichever share token endpoint is used and not need
// the helper link functions at the bottom of this file
function getRoomShareToken(roomSid) {
    return __awaiter(this, void 0, void 0, function* () {
        const resp = yield api_1.StreemAPI.rooms.listRoomShareTokens(roomSid);
        if (resp.shareTokens && resp.shareTokens.length > 0) {
            return resp.shareTokens[0].sid;
        }
        else
            return undefined;
    });
}
function createShareToken(roomSid) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const resp = yield api_1.StreemAPI.rooms.createRoomShareToken(roomSid);
        return ((_a = resp.shareToken) === null || _a === void 0 ? void 0 : _a.sid) || '';
    });
}
const useShareLink = ({ roomSid, anonymousShareEnabled, token, artifactSid, }) => {
    const [link, setLink] = (0, react_1.useState)(null);
    const refreshLink = (0, react_1.useCallback)(() => {
        const isAnonymousPage = Boolean(token);
        function setAnonymousShareLinkWithToken(roomSid, artifactSid) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const token = (yield getRoomShareToken(roomSid)) || (yield createShareToken(roomSid));
                    setLink((0, exports.anonymousShareLinkUrl)(roomSid, artifactSid, token));
                }
                catch (err) {
                    setLink('error!');
                }
            });
        }
        // If viewing anonymous call details, use all values from the route
        if (isAnonymousPage) {
            setLink((0, exports.anonymousShareLinkUrl)(roomSid, artifactSid, token));
        }
        else {
            // If viewing auth'd call details, determine if we need to generate a share token.
            // 1. Check company setting: Are we generating anonymous urls? If no, we're done.
            // 2. If we are, check for existence of previously generated tokens and re-use, if present.
            // 3. If not present, create the token and use it.
            if (anonymousShareEnabled) {
                setAnonymousShareLinkWithToken(roomSid, artifactSid);
            }
            else {
                setLink((0, exports.authenticatedShareLinkUrl)(roomSid, artifactSid));
            }
        }
    }, [roomSid, artifactSid, token, anonymousShareEnabled]);
    return [link, refreshLink];
};
exports.useShareLink = useShareLink;
const anonymousShareLinkUrl = (roomId, artifactId, token) => {
    const path = detailPath(roomId, artifactId);
    return token ? `${window.location.origin}/share/${token}/${path}` : '';
};
exports.anonymousShareLinkUrl = anonymousShareLinkUrl;
const authenticatedShareLinkUrl = (roomId, artifactId) => {
    const path = detailPath(roomId, artifactId);
    return `${window.location.origin}/share/${path}`;
};
exports.authenticatedShareLinkUrl = authenticatedShareLinkUrl;
const detailPath = (roomId, artifactId) => {
    if (!roomId) {
        return '';
    }
    const parts = ['details', roomId];
    if (artifactId) {
        parts.push('artifact', artifactId);
    }
    return parts.join('/');
};
//# sourceMappingURL=use_share_link.js.map